// extracted by mini-css-extract-plugin
module.exports = {"container":"breadcrumbs-module--container--2YGpi","carat":"breadcrumbs-module--carat--3Wf1g","link":"breadcrumbs-module--link--TyaWN","active":"breadcrumbs-module--active--3cJZo"};